import { MutationResult } from '@apollo/react-common';

export function mutationDidSucceed<T>({
  called,
  data,
  error,
  loading,
}: MutationResult<T>): boolean {
  return !!(called && !loading && !error && data);
}
